const prefix = '/leads';

const ApiRoutes = {
  ReadAll: prefix,
  UpsertOne: prefix,
  ReadContact: prefix + '/contacts/{id}',
  AssignedTherapist: prefix + '/contacts/assigned-therapist',
  ClaimLead: prefix + '/{leadId}/claim',
  CancelClaim: prefix + '/{leadId}/claim/cancel',
  RevealPhone: prefix + '/{leadId}/reveal-phone',
  SaveNotes: prefix + '/{leadId}/notes',
  SetCallStatus: prefix + '/{leadId}/call-status',
  HideLead: prefix + '/{leadId}/hide',
};

export default ApiRoutes;
